import Button from "devextreme-react/button";
import {useContext, useRef, useState} from "react";
import {EstimateContext} from "../context/EstimateContext";
import {usePrintInternalCost} from "../api/print-internal-cost";
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import {TextBox} from "devextreme-react/text-box";
import {Validator, RequiredRule, CustomRule} from "devextreme-react/validator";
import {ValidationSummary} from "devextreme-react/validation-summary";
import {Buffer} from 'buffer';

export default function PrintInternalCostButton() {
    const {order} = useContext(EstimateContext);
    const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
    const reftb = useRef<TextBox>(null);
    const refIsValid = useRef<boolean>(true);
    const printInternalCost = usePrintInternalCost(order.details.quoteID);

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => setIsPopupVisible(false)
    };

    return (
        <>
            <Popup
                visible={isPopupVisible}
                showTitle={true}
                width={300}
                height={280}
                title={"Confirm password"}
                shading={true}
                showCloseButton={true}
                onHidden={() => {
                    setIsPopupVisible(false);
                }}
                position={'center'}
            > <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                disabled={printInternalCost.isLoading}
                options={{
                    stylingMode: 'contained',
                    text: 'OK',
                    validationGroup: 'printInternalCost',
                    onClick: async (e: any) => {
                        if (e.validationGroup.validate().isValid) {
                            let reportResult = await printInternalCost.mutateAsync({password: reftb.current?.instance.option("value") ?? ''});
                            if (!reportResult.isSuccess) {
                                refIsValid.current = false;
                                return;
                            }
                            const file = new File(
                                [Buffer.from(reportResult.data, "base64")],
                                order.details.quoteNumber + '-Internal.pdf',
                                {type: 'application/pdf'});

                            const fileURL = URL.createObjectURL(file);
                            window.open(fileURL);
                        }
                    },
                }}
            />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <TextBox
                            mode={'password'}
                            width={'100%'}
                            label='Password'
                            labelMode={'outside'}
                            inputAttr={{autocomplete: 'new-password'}}
                            ref={reftb}
                            onInput={(e) => {
                                refIsValid.current = true;
                            }
                            }
                        >
                            <Validator validationGroup="printInternalCost">
                                <RequiredRule message={'Password is required'}/>
                                <CustomRule reevaluate={false} message={'Invalid password'} validationCallback={() => {
                                    return refIsValid.current;
                                }}></CustomRule>
                            </Validator>
                        </TextBox>
                    </div>
                    <ValidationSummary validationGroup='printInternalCost'></ValidationSummary>
                </div>
            </Popup>
            <Button
                text="Print Internal Cost"
                icon="Inscyth-Print"
                visible={order.details.isPrintInternalCostAvailable}
                onClick={() => {
                    reftb.current?.instance.clear();
                    refIsValid.current = true;
                    setIsPopupVisible(true);
                }}>
            </Button>
        </>
    )
}
